import React, { useCallback, useState } from "react";
import Button from "../../components/Button";
import { Text, View } from "react-native";
import VStack from "../../ui_atoms/VStack";
import type { Meta, StoryObj } from "@storybook/react";
import LoadingModal from "../../components/LoadingModal";

const ComponentStory = () => {
    const [isVisible, setIsVisible] = useState(false);
    const onPress = useCallback(() => {
        setIsVisible(true);
        setTimeout(() => setIsVisible(false), 5000);
    }, []);
    return (
        <VStack gap={0.5} alignment="stretch" style={{ width: "100%" }}>
            <Button label="Show modal" onPress={onPress} />
            <LoadingModal
                visible={isVisible}
                text={
                    "I am **waiting** 5 sec, \n\n*or less*\n\nThis is a longer text that should be wrapped to multiple line if the system works"
                }
            />
            {isVisible ? <Text>VISIBLE</Text> : null}
        </VStack>
    );
};

const meta = {
    title: "Components/LoadingModal",
    component: ComponentStory,
    argTypes: {},
    decorators: [
        (StoryFn) => (
            <View style={{ flex: 1, justifyContent: "center", alignItems: "center", padding: 10 }}>
                <StoryFn />
            </View>
        ),
    ],
} satisfies Meta<typeof ComponentStory>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {
    args: {},
};
